<style lang="scss" scoped>
.file-upload {
    transition: border 0.2s;
    border: 1px solid var(--border-color);
    font-size: 1rem;
    font-weight: 400;
    position: relative;
    max-height: 350px;
    display: flex;
    width: 100%;
    .drop-active {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        background: #fff;
        align-items: center;
        display: flex;
        justify-content: center;
        border: 1px solid var(--primary);
    }
    .upload {
        max-height: inherit;
    }
    .image-preview {
        width: 100%;
        height: auto;
        max-height: inherit;
        object-fit: contain;
    }
}
</style>

<template>
    <div>
        <div class="d-flex mb-8">
            <label class="small mb-0"> Photo </label>
            <a href="#" @click="$emit('reset')" class="small text-right ml-auto d-block mb-0">{{ $t('form-elements.reset_image') }}</a>
        </div>
        <div class="file-upload">
            <div class="upload h-100 w-100">
                <img v-if="files.length" :src="files[0].blob" class="image-preview" />
                <img v-else-if="preview" :src="preview.default" class="image-preview" />
                <div v-else class="h-100 w-100">
                    <div class="text-center p-5">
                        <p class="fw-b mb-8">{{ $t('form-elements.drag_files_here') }}</p>
                        <p class="mb-8">{{ $t('form-elements.or') }}</p>
                        <label :for="`input_${_uid}`" class="btn btn-lg btn-primary">{{ $t('form-elements.select_a_file') }}</label>
                    </div>
                </div>

                <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                    <p class="fw-b mb-8">{{ $t('form-elements.drag_files_here') }}</p>
                </div>

                <file-upload :input-id="`input_${_uid}`" extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp" :drop-directory="true" :multiple="false" :drop="true" v-model="files" ref="upload" @input-filter="inputFilter">

                </file-upload>
            </div>

        </div>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
export default {
    components: {
        FileUpload,
    },
    props: {
        value: {
            required: true,
            type: Array
        },
        preview: {
            required: false
        }
    },
    data() {
        return {
            files: this.value,
        }
    },
    methods: {
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Add file

                // Filter non-image file
                // Will not be added to files
                if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                    return prevent()
                }

                // Create the 'blob' field for thumbnail preview
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }

            }

            if (newFile && oldFile) {
                // Update file

                // Increase the version number
                if (!newFile.version) {
                    newFile.version = 0
                }
                newFile.version++
            }

            if (!newFile && oldFile) {
                // Remove file

                // Refused to remove the file
                // return prevent()
            }

            this.$nextTick().then(() => {
                this.$emit('input', this.files)
            })
        }
    },
    watch: {
        value() {
            this.files = this.value
        }
    }
}
</script>